import { SxProps } from '@mui/system';

const headerCotnainer: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  img: {
    verticalAlign: 'middle',
  },
};

const headerDivider: SxProps = {
  height: 40,
  alignSelf: 'center',
  marginX: 4,
  border: '1px solid grey',
  borderColor: 'neutral.80',
};

export default {
  headerCotnainer,
  headerDivider,
};
